// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"845":"profile","966":"dashboard"}[chunkId] || chunkId) + "." + {"9":"4c88cc83","56":"7c2fb31e","124":"7c2fb31e","357":"7543a671","435":"a91fd39c","461":"7543a671","508":"82316fb2","730":"2337e363","845":"05223309","922":"a40fbc31","966":"1137d690"}[chunkId] + ".css";
};